/**
 * 리포트–결함 지도 동기화 파이프라인 전용 로그.
 * 콘솔 필터: REPORT-DEFECT-PIPELINE
 */

import { isAppDebugEnabled } from '@/utils/debug/debugEnv';

const PREFIX = '[REPORT-DEFECT-PIPELINE]';

let _pipelineCorrelationSeq = 0;

/** intent →(debounce)→ execute 를 같은 번호로 묶기 위한 단조 증가 id */
export function nextPipelineCorrelationId() {
  return ++_pipelineCorrelationSeq;
}

/**
 * @returns {boolean} production에서는 기본 off. VUE_APP_REPORT_DEFECT_PIPELINE_LOG로 강제 on/off.
 */
export function isPipelineLogEnabled() {
  const v = process.env.VUE_APP_REPORT_DEFECT_PIPELINE_LOG;
  if (v === 'true') return true;
  if (v === 'false') return false;
  return isAppDebugEnabled();
}

/**
 * @param {'intent'|'phase'|'warn'|'error'} kind
 * @param {string} message 짧은 한 줄 설명
 * @param {Record<string, unknown>} [payload]
 */
export function logPipeline(kind, message, payload) {
  if (!isPipelineLogEnabled()) return;
  const line = { kind, message, ...((payload && typeof payload === 'object') ? payload : {}) };
  if (kind === 'error') {
    console.error(PREFIX, line);
    return;
  }
  if (kind === 'warn') {
    console.warn(PREFIX, line);
    return;
  }
  console.log(PREFIX, line);
}
